// app/login/loginPageMessages.ts

export interface LoginSearchParams {
  get(name: string): string | null;
}

export interface LoginPageMessages {
  error: string | null;
  notice: string | null;
}

function decodeParam(value: string): string {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}

export function getLoginPageMessages(
  searchParams: LoginSearchParams,
): LoginPageMessages {
  const errorParam = searchParams.get("error");
  if (errorParam) {
    return { error: decodeParam(errorParam), notice: null };
  }

  const messageParam = searchParams.get("message");
  if (messageParam) {
    return { error: null, notice: decodeParam(messageParam) };
  }

  if (searchParams.get("logout") === "success") {
    return {
      error: null,
      notice: "You have been successfully signed out.",
    };
  }

  return { error: null, notice: null };
}

export function getValidatedRedirectedFrom(
  searchParams: LoginSearchParams,
): string | undefined {
  const redirectedFrom = searchParams.get("redirectedFrom") || undefined;
  if (
    !redirectedFrom ||
    !redirectedFrom.startsWith("/") ||
    redirectedFrom.startsWith("//")
  ) {
    return undefined;
  }
  return redirectedFrom;
}
